'use strict';

var _ = require('lodash');
var Moment = require('moment');
var SpecialEventsService = function SpecialEventsService($filter, Event, momentService, seasonalityCommonService, daysOfWeekHelper, seasonalityConstants) {
  var WEEK_DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  var TYPES = seasonalityConstants.SPECIAL_EVENT_TYPES;
  var STATUSES = seasonalityConstants.CALENDAR_STATUSES;
  var rmMomentFormat = $filter('rmMomentFormat');
  var eventTypeMap = {
    'THANKSGIVING': TYPES.FIXED_DATE,
    'CHRISTMAS': TYPES.FIXED_DATE,
    'SUPER BOWL': TYPES.MOVING,
    'EASTER': TYPES.FIXED_WOY,
    'SPRING BREAK': TYPES.MOVING
  };
  function isEventFixedWOY(name) {
    var eventType = eventTypeMap[name.toUpperCase()];
    return eventType === TYPES.FIXED_WOY;
  }
  function isEventForContinuedYears(eventType) {
    return eventType === TYPES.FIXED_WOY || eventType === TYPES.FIXED_DATE;
  }
  function getDatesForFixedWeekOfYearEvents(startYear, endYear, specialEventWeeklyDataPoint) {
    var departureDateMoment = momentService.of(specialEventWeeklyDataPoint.departureDate, momentService.FIELD.DEPARTURE_DATE);
    var weekOfYear = seasonalityCommonService.seasonalityWeekOfYear(departureDateMoment);
    var day = _.toLower(rmMomentFormat(departureDateMoment, 'DAY_OF_WEEK'));
    var dayOfWeek = _.indexOf(WEEK_DAYS, day);
    var currentYear = momentService.now(momentService.FIELD.DEPARTURE_DATE).year();
    var currentYearPlus = currentYear + 1;
    var result = [];
    for (var i = startYear; i <= endYear; i++) {
      result.push(getDateStringForDayWeekYear(dayOfWeek, weekOfYear, i));
    }
    result.push(getDateStringForDayWeekYear(dayOfWeek, weekOfYear, currentYear));
    result.push(getDateStringForDayWeekYear(dayOfWeek, weekOfYear, currentYearPlus));
    return _.uniq(result);
  }
  function getDatesForContinuedEvents(startYear, endYear, specialEventWeeklyDataPoint, type) {
    if (type === TYPES.FIXED_WOY) {
      return getDatesForFixedWeekOfYearEvents(startYear, endYear, specialEventWeeklyDataPoint);
    }
    var specialEventDepartureDate = momentService.of(specialEventWeeklyDataPoint.departureDate, momentService.FIELD.DEPARTURE_DATE);
    var dataPointYear = specialEventDepartureDate.year();
    var dataPointDate = specialEventDepartureDate.format(momentService.FORMAT.DATE_ISO);
    var currentYear = momentService.now(momentService.FIELD.DEPARTURE_DATE).year();
    var currentYearPlus = currentYear + 1;
    var result = [];
    for (var i = startYear; i <= endYear; i++) {
      result.push(_.replace(dataPointDate, dataPointYear, i));
    }
    if (dataPointYear <= currentYear) {
      result.push(_.replace(dataPointDate, dataPointYear, currentYear));
    }
    result.push(_.replace(dataPointDate, dataPointYear, currentYearPlus));
    return _.uniq(result);
  }
  function getDateStringForDayWeekYear(dayOfWeek, weekOfYear, year) {
    var firstMondayOfYear = daysOfWeekHelper.getFirstDayOfDow(year, 'Mon');
    var dateMoment = firstMondayOfYear.add(weekOfYear - 1, 'weeks').add(dayOfWeek, 'days');
    return rmMomentFormat(dateMoment, 'DATE_ISO');
  }
  function dataPrepForSpecialEvents(data, selectedMarket, calStatus) {
    var calStatusFlag = false;
    if (calStatus && (calStatus === STATUSES.COMPLETED || calStatus === STATUSES.FINISHED)) {
      calStatusFlag = true;
    }
    var currentDate = new Moment();
    return _.chain(data).filter({
      market: selectedMarket
    }).map(function (row) {
      var rowEditableAndRemovableFlag = row.eventType === TYPES.MOVING && (row.startDate.isSame(currentDate) || row.startDate.isAfter(currentDate)) && calStatusFlag;
      var specialEvent = _.pick(row, ['market', 'eventType', 'eventName', 'startDate', 'endDate']);
      specialEvent.isRowRemovable = rowEditableAndRemovableFlag;
      specialEvent.isRowEditable = rowEditableAndRemovableFlag;
      return specialEvent;
    }).value();
  }
  function createSpecialEventsRequest(data) {
    var specialEvents = [];
    _.forEach(data, function (data) {
      if (data.market !== null && data.market !== undefined) {
        _.forEach(data.market.split(','), function (market) {
          specialEvents.push(new Event({
            market: market,
            name: data.eventName,
            type: data.eventType,
            startDateMoment: data.startDate,
            endDateMoment: data.endDate
          }));
        });
      }
    });
    return specialEvents;
  }
  function buildUserExclusionEventsData(newEventsList, gridData) {
    var result = {};
    var dowSelection = [];
    if (newEventsList && newEventsList.length > 0) {
      var firstEvent = _.first(newEventsList);
      result.market = firstEvent.market;
      dowSelection = firstEvent.dowSelection;
      if (firstEvent.allWeek) {
        dowSelection = WEEK_DAYS;
      }
    }
    var allDatesToBeAdded = [];
    var existingEventsToBeRemoved = [];
    _.forEach(newEventsList, function (event) {
      var data = getAddAndRemoveData(event, gridData, result.market, dowSelection);
      allDatesToBeAdded = _.unionWith(allDatesToBeAdded, data.add, function (moment1, moment2) {
        return moment1.isSame(moment2, 'day');
      });
      existingEventsToBeRemoved = _.unionWith(existingEventsToBeRemoved, data.remove, function (obj1, obj2) {
        return obj1.startDate === obj2.startDate && obj1.endDate === obj2.endDate;
      });
    });
    result.add = createDateRangesFromDatesArray(allDatesToBeAdded);
    result.remove = existingEventsToBeRemoved;
    return result;
  }
  function getAddAndRemoveData(newUserExclusionEvent, gridData, market, dowSelection) {
    var firstDate = newUserExclusionEvent.startDateMoment.startOf('isoWeek');
    var lastDate = firstDate.add(6, 'days');
    var eventsToRemove = getExistingEventsToBeRemoved(gridData, market, firstDate, lastDate);
    eventsToRemove = _.map(eventsToRemove, function (eventToRemove) {
      return _.pick(eventToRemove, ['startDate', 'endDate']);
    });
    var dateRangeArray = getDatesArray(firstDate, lastDate);
    var selectedDatesArray = filteredDatesForSelectedDow(dateRangeArray, dowSelection);
    var datesToAdd = getAllDatesToAdd(selectedDatesArray, eventsToRemove);
    return {
      add: datesToAdd,
      remove: eventsToRemove
    };
  }
  function getDatesArray(startDate, endDate) {
    var dateRange = [];
    var oneDayAfterEndDate = endDate.add(1, 'days');
    var currDate = startDate;
    while (currDate.isBefore(oneDayAfterEndDate, 'day')) {
      dateRange.push({
        day: _.toLower(rmMomentFormat(currDate, 'DAY_OF_WEEK')),
        date: currDate
      });
      currDate = currDate.add(1, 'days');
    }
    return dateRange;
  }
  function getAllDatesToAdd(selectedDatesArray, removeEvents) {
    var result = selectedDatesArray;
    _.forEach(removeEvents, function (event) {
      var removeDatesArray = getDatesArray(event.startDate, event.endDate);
      removeDatesArray = _.map(removeDatesArray, 'date');
      result = _.unionWith(result, removeDatesArray, function (moment1, moment2) {
        return moment1.isSame(moment2, 'day');
      });
    });
    result.sort(function (moment1, moment2) {
      if (moment1.isBefore(moment2, 'day')) {
        return -1;
      } else if (moment1.isAfter(moment2, 'day')) {
        return 1;
      }
      return 0;
    });
    return result;
  }
  function filteredDatesForSelectedDow(dateRangeArray, dowSelection) {
    return _.chain(dateRangeArray).filter(function (date) {
      return _.includes(dowSelection, date.day);
    }).map('date').value();
  }
  function createDateRangesFromDatesArray(datesArray) {
    var results = [];
    var start = datesArray[0];
    var end = start;
    _.chain(datesArray).drop().value().map(function (date) {
      if (date.diff(end, 'days') === 1) {
        end = date;
      } else {
        results.push(buildUserExclusionDateObject(start, end));
        start = date;
        end = start;
      }
      return date;
    });
    results.push(buildUserExclusionDateObject(start, end));
    return results;
  }
  function buildUserExclusionDateObject(startDate, endDate) {
    var result = {};
    result.startDate = startDate;
    result.endDate = endDate;
    return result;
  }
  function getExistingEventsToBeRemoved(gridData, market, firstDate, lastDate) {
    return _.filter(gridData, function (gridEvent) {
      return gridEvent.market === market && gridEvent.eventType === 'Excluded' && gridEvent.eventName === 'UserExcluded' && isContiguousOrOverlapping(gridEvent.startDate, gridEvent.endDate, firstDate, lastDate);
    });
  }
  function isContiguousOrOverlapping(startDate1, endDate1, startDate2, endDate2) {
    // add one day to endDates to consider consecutive dates
    // example: startDate1 = 13-Jun, endDate1 = 19-Jun
    //      and startDate2 = 20-Jun, endDate2 = 26-Jun
    // above dates are contiguous from 13-Jun to 26-Jun
    endDate1 = endDate1.add(1, 'days');
    endDate2 = endDate2.add(1, 'days');
    return (startDate1.isSame(endDate2) || startDate1.isBefore(endDate2)) && (endDate1.isSame(startDate2) || endDate1.isAfter(startDate2));
  }
  function isOverlapping(startDate1, endDate1, startDate2, endDate2) {
    return (startDate1.isSame(endDate2) || startDate1.isBefore(endDate2)) && (endDate1.isSame(startDate2) || endDate1.isAfter(startDate2));
  }
  function checkEmptyDataInSpecialEvents(specialEvents) {
    var isBlank = false;
    _.forEach(specialEvents, function (spEvent) {
      if (!spEvent.endDate || !spEvent.eventName || !spEvent.eventType || !spEvent.startDate) {
        isBlank = true;
      }
    });
    return isBlank;
  }
  function checkOverLappingDatesInEvents(specialEvents) {
    var validationResult = '_clear';
    for (var first = 0; first < specialEvents.length; first++) {
      for (var second = first + 1; second < specialEvents.length; second++) {
        if (isOverlapping(specialEvents[first].startDate, specialEvents[first].endDate, specialEvents[second].startDate, specialEvents[second].endDate)) {
          validationResult = 'Overlapping date ranges detected between : ' + specialEvents[first].eventName + ' and ' + specialEvents[second].eventName + ' please rectify and try again';
          break;
        }
      }
    }
    return validationResult;
  }
  function detectEventTypesInSpecialEvents(specialEvents, eventType) {
    return _.filter(specialEvents, {
      eventType: eventType
    });
  }
  function validateDemandCalendarSpecialEventsGrid(specialEvents) {
    var validationErrorMessage = 'One or more properties of the special events created are empty, please enter valid values and continue';
    if (!specialEvents || specialEvents.length === 1) {
      return '_clear';
    }
    var containsMovingEvent = detectEventTypesInSpecialEvents(specialEvents, 'Moving');
    if (containsMovingEvent.length === 0) {
      return '_clear';
    }
    return checkEmptyDataInSpecialEvents(specialEvents) ? validationErrorMessage : checkOverLappingDatesInEvents(specialEvents);
  }
  function compareEvents(originalEvent, gridEvent) {
    return !!(originalEvent.eventType === gridEvent.eventType && originalEvent.eventName === gridEvent.eventName && originalEvent.startDate.value.isSame(gridEvent.startDate.value) && originalEvent.endDate.value.isSame(gridEvent.endDate.value));
  }
  function detectChangedEvents(originalSpecialEvents, changedSpecialEvents) {
    var originalEventsLength = _.size(originalSpecialEvents);
    var changedSpecialEventsLength = changedSpecialEvents ? changedSpecialEvents.length : 0;
    if (originalEventsLength !== changedSpecialEventsLength && changedSpecialEventsLength) {
      return returnChangedMovingSpecialEvents(changedSpecialEvents, originalSpecialEvents);
    }
    var changeFlag = originalEventsLength;
    for (var i = 0; i < originalEventsLength; i++) {
      for (var j = 0; j < changedSpecialEventsLength; j++) {
        if (compareEvents(originalSpecialEvents[i], changedSpecialEvents[j])) {
          changeFlag--;
        }
      }
    }
    return changeFlag !== 0 ? returnChangedMovingSpecialEvents(changedSpecialEvents, originalSpecialEvents) : [];
  }
  function returnChangedMovingSpecialEvents(specialEventsFromGrid, originalSpecialEvents) {
    var changedSpecialEvents = detectEventTypesInSpecialEvents(specialEventsFromGrid, 'Moving');
    if (changedSpecialEvents.length === 0) {
      return [{
        endDate: originalSpecialEvents[0].endDate,
        event: null,
        eventType: null,
        market: originalSpecialEvents[0].market,
        startDate: originalSpecialEvents[0].startDate
      }];
    }
    return changedSpecialEvents;
  }
  function createSpecialEventsOverrideArrayObject(changedSpecialEvents, market) {
    var result = [];
    _.forEach(changedSpecialEvents, function (chneve) {
      var eve = {
        market: _.includes(market, '-') ? market.replace('-', '') : market,
        startDepartureDate: chneve.startDate.toISOString(),
        endDepartureDate: chneve.endDate.toISOString(),
        eventName: chneve.eventName,
        eventType: chneve.eventType
      };
      result.push(eve);
    });
    return result;
  }
  function createSpecialEventsOverride(changedSpecialEvents, market) {
    return {
      classGroup: null,
      dowGroup: null,
      significantPOS: null,
      weekNo: null,
      year: null,
      season: null,
      marketSpecialEvents: createSpecialEventsOverrideArrayObject(changedSpecialEvents, market)
    };
  }
  return {
    getDatesForFixedWeekOfYearEvents: getDatesForFixedWeekOfYearEvents,
    createSpecialEventsRequest: createSpecialEventsRequest,
    buildUserExclusionEventsData: buildUserExclusionEventsData,
    dataPrepForSpecialEvents: dataPrepForSpecialEvents,
    validateDemandCalendarSpecialEventsGrid: validateDemandCalendarSpecialEventsGrid,
    detectEventTypesInSpecialEvents: detectEventTypesInSpecialEvents,
    detectChangedEvents: detectChangedEvents,
    createSpecialEventsOverride: createSpecialEventsOverride,
    isEventForContinuedYears: isEventForContinuedYears,
    getDatesForContinuedEvents: getDatesForContinuedEvents,
    isEventFixedWOY: isEventFixedWOY
  };
};
SpecialEventsService.$inject = ['$filter', 'EventFactory', 'MomentService', 'SeasonalityCommonService', 'DaysOfWeekHelper', 'SeasonalityConstants'];
module.exports = SpecialEventsService;